// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__3Y_xn","previous":"style_previous__2IdQp","next":"style_next__3rFI4","formatter":"style_formatter__2evVq"};